const hasNonEmptyText = (node) => {
  if (!node) return false
  if (node.nodeType === 'text') return Boolean(node.value?.trim())
  return Array.isArray(node.content) && node.content.some(hasNonEmptyText)
}

const resolveCopyrightMessage = (rawCopyrightMessage, fallback) => {
  return rawCopyrightMessage?.nodeType === 'document' && hasNonEmptyText(rawCopyrightMessage)
    ? rawCopyrightMessage
    : fallback
}

export { hasNonEmptyText, resolveCopyrightMessage }
